/*Global*/
import logo from '../assets/Logo/Logo.png';

/*Home*/
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';

/*Partners*/
import partner1 from '../assets/Partners/Partner-1.png';
import partner2 from '../assets/Partners/Partner-2.png';
import partner3 from '../assets/Partners/Partner-3.png';
import partner4 from '../assets/Partners/Partner-4.png';
import partner5 from '../assets/Partners/Partner-5.png';
import partner6 from '../assets/Partners/Partner-6.png';
import partner7 from '../assets/Partners/Partner-7.png';
import partner8 from '../assets/Partners/Partner-8.png';

/*About*/ 
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';
import about3 from '../assets/About/About-3.jpg';


/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';


/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Gallery*/
import gallery1 from '../assets/Gallery/Gallery-1.jpg';
import gallery2 from '../assets/Gallery/Gallery-2.jpg';
import gallery3 from '../assets/Gallery/Gallery-3.jpg';
import gallery4 from '../assets/Gallery/Gallery-4.jpg';
import gallery5 from '../assets/Gallery/Gallery-5.jpg';
import gallery6 from '../assets/Gallery/Gallery-6.jpg';
import gallery7 from '../assets/Gallery/Gallery-7.jpg';
import gallery8 from '../assets/Gallery/Gallery-8.jpg';
import gallery9 from '../assets/Gallery/Gallery-9.jpg';
import gallery10 from '../assets/Gallery/Gallery-10.jpg';
import gallery11 from '../assets/Gallery/Gallery-11.jpg';
import gallery12 from '../assets/Gallery/Gallery-12.jpg';


/*Careers*/
import careerIntro from '../assets/Career/Intro/Intro.jpg';
import position1 from '../assets/Career/Positions/Position-1.jpg';
import position2 from '../assets/Career/Positions/Position-2.jpg';
import position3 from '../assets/Career/Positions/Position-3.jpg';
import position4 from '../assets/Career/Positions/Position-4.jpg';
import position5 from '../assets/Career/Positions/Position-5.jpg';
import position6 from '../assets/Career/Positions/Position-6.jpg';


/*Pricing*/
import plan1 from '../assets/Pricing/Plan-1.jpg';
import plan2 from '../assets/Pricing/Plan-2.jpg';
import plan3 from '../assets/Pricing/Plan-3.jpg';


/*Projects*/
import project1 from '../assets/Project/Projects/Project-1.jpg';
import project1Gallery1 from '../assets/Project/Gallery/1.jpg';
import project1Gallery2 from '../assets/Project/Gallery/2.jpg';
import project1Gallery3 from '../assets/Project/Gallery/3.jpg';
import project1Gallery4 from '../assets/Project/Gallery/4.jpg';
import project1Gallery5 from '../assets/Project/Gallery/5.jpg';
import project1Gallery6 from '../assets/Project/Gallery/6.jpg';

import project2 from '../assets/Project/Projects/Project-2.jpg';
import project2Gallery1 from '../assets/Project/Gallery/1.jpg';
import project2Gallery2 from '../assets/Project/Gallery/2.jpg';
import project2Gallery3 from '../assets/Project/Gallery/3.jpg';
import project2Gallery4 from '../assets/Project/Gallery/4.jpg';
import project2Gallery5 from '../assets/Project/Gallery/5.jpg';
import project2Gallery6 from '../assets/Project/Gallery/6.jpg';

import project3 from '../assets/Project/Projects/Project-3.jpg';
import project3Gallery1 from '../assets/Project/Gallery/1.jpg';
import project3Gallery2 from '../assets/Project/Gallery/2.jpg';
import project3Gallery3 from '../assets/Project/Gallery/3.jpg';
import project3Gallery4 from '../assets/Project/Gallery/4.jpg';
import project3Gallery5 from '../assets/Project/Gallery/5.jpg';
import project3Gallery6 from '../assets/Project/Gallery/6.jpg';

import project4 from '../assets/Project/Projects/Project-4.jpg';
import project4Gallery1 from '../assets/Project/Gallery/1.jpg';
import project4Gallery2 from '../assets/Project/Gallery/2.jpg';
import project4Gallery3 from '../assets/Project/Gallery/3.jpg';
import project4Gallery4 from '../assets/Project/Gallery/4.jpg';
import project4Gallery5 from '../assets/Project/Gallery/5.jpg';
import project4Gallery6 from '../assets/Project/Gallery/6.jpg';

import project5 from '../assets/Project/Projects/Project-5.jpg';
import project5Gallery1 from '../assets/Project/Gallery/1.jpg';
import project5Gallery2 from '../assets/Project/Gallery/2.jpg';
import project5Gallery3 from '../assets/Project/Gallery/3.jpg';
import project5Gallery4 from '../assets/Project/Gallery/4.jpg';
import project5Gallery5 from '../assets/Project/Gallery/5.jpg';
import project5Gallery6 from '../assets/Project/Gallery/6.jpg';

import project6 from '../assets/Project/Projects/Project-6.jpg';
import project6Gallery1 from '../assets/Project/Gallery/1.jpg';
import project6Gallery2 from '../assets/Project/Gallery/2.jpg';
import project6Gallery3 from '../assets/Project/Gallery/3.jpg';
import project6Gallery4 from '../assets/Project/Gallery/4.jpg';
import project6Gallery5 from '../assets/Project/Gallery/5.jpg';
import project6Gallery6 from '../assets/Project/Gallery/6.jpg';


/*Destinations*/
import des1 from '../assets/Destination/Destinations/Destination-1.jpg';
import des1Gallery1 from '../assets/Destination/Gallery/1.jpg';
import des1Gallery2 from '../assets/Destination/Gallery/2.jpg';
import des1Gallery3 from '../assets/Destination/Gallery/3.jpg';
import des1Gallery4 from '../assets/Destination/Gallery/4.jpg';
import des1Gallery5 from '../assets/Destination/Gallery/5.jpg';
import des1Gallery6 from '../assets/Destination/Gallery/6.jpg';

import des2 from '../assets/Destination/Destinations/Destination-2.jpg';
import des2Gallery1 from '../assets/Destination/Gallery/1.jpg';
import des2Gallery2 from '../assets/Destination/Gallery/2.jpg';
import des2Gallery3 from '../assets/Destination/Gallery/3.jpg';
import des2Gallery4 from '../assets/Destination/Gallery/4.jpg';
import des2Gallery5 from '../assets/Destination/Gallery/5.jpg';
import des2Gallery6 from '../assets/Destination/Gallery/6.jpg';

import des3 from '../assets/Destination/Destinations/Destination-3.jpg';
import des3Gallery1 from '../assets/Destination/Gallery/1.jpg';
import des3Gallery2 from '../assets/Destination/Gallery/2.jpg';
import des3Gallery3 from '../assets/Destination/Gallery/3.jpg';
import des3Gallery4 from '../assets/Destination/Gallery/4.jpg';
import des3Gallery5 from '../assets/Destination/Gallery/5.jpg';
import des3Gallery6 from '../assets/Destination/Gallery/6.jpg';

import des4 from '../assets/Destination/Destinations/Destination-4.jpg';
import des4Gallery1 from '../assets/Destination/Gallery/1.jpg';
import des4Gallery2 from '../assets/Destination/Gallery/2.jpg';
import des4Gallery3 from '../assets/Destination/Gallery/3.jpg';
import des4Gallery4 from '../assets/Destination/Gallery/4.jpg';
import des4Gallery5 from '../assets/Destination/Gallery/5.jpg';
import des4Gallery6 from '../assets/Destination/Gallery/6.jpg';

import des5 from '../assets/Destination/Destinations/Destination-5.jpg';
import des5Gallery1 from '../assets/Destination/Gallery/1.jpg';
import des5Gallery2 from '../assets/Destination/Gallery/2.jpg';
import des5Gallery3 from '../assets/Destination/Gallery/3.jpg';
import des5Gallery4 from '../assets/Destination/Gallery/4.jpg';
import des5Gallery5 from '../assets/Destination/Gallery/5.jpg';
import des5Gallery6 from '../assets/Destination/Gallery/6.jpg';

import des6 from '../assets/Destination/Destinations/Destination-6.jpg';
import des6Gallery1 from '../assets/Destination/Gallery/1.jpg';
import des6Gallery2 from '../assets/Destination/Gallery/2.jpg';
import des6Gallery3 from '../assets/Destination/Gallery/3.jpg';
import des6Gallery4 from '../assets/Destination/Gallery/4.jpg';
import des6Gallery5 from '../assets/Destination/Gallery/5.jpg';
import des6Gallery6 from '../assets/Destination/Gallery/6.jpg';

/*Tours*/
import tour1 from '../assets/Tour/Tours/Tour-1.jpg';
import tour1Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour1Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour1Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour1Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour1Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour1Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour1Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour1Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour2 from '../assets/Tour/Tours/Tour-2.jpg';
import tour2Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour2Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour2Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour2Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour2Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour2Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour2Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour2Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour3 from '../assets/Tour/Tours/Tour-3.jpg';
import tour3Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour3Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour3Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour3Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour3Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour3Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour3Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour3Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour4 from '../assets/Tour/Tours/Tour-4.jpg';
import tour4Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour4Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour4Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour4Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour4Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour4Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour4Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour4Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour5 from '../assets/Tour/Tours/Tour-5.jpg';
import tour5Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour5Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour5Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour5Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour5Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour5Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour5Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour5Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour6 from '../assets/Tour/Tours/Tour-6.jpg';
import tour6Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour6Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour6Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour6Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour6Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour6Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour6Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour6Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour7 from '../assets/Tour/Tours/Tour-7.jpg';
import tour7Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour7Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour7Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour7Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour7Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour7Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour7Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour7Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour8 from '../assets/Tour/Tours/Tour-8.jpg';
import tour8Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour8Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour8Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour8Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour8Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour8Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour8Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour8Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour9 from '../assets/Tour/Tours/Tour-9.jpg';
import tour9Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour9Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour9Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour9Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour9Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour9Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour9Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour9Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour10 from '../assets/Tour/Tours/Tour-10.jpg';
import tour10Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour10Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour10Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour10Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour10Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour10Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour10Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour10Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour11 from '../assets/Tour/Tours/Tour-11.jpg';
import tour11Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour11Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour11Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour11Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour11Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour11Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour11Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour11Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour12 from '../assets/Tour/Tours/Tour-12.jpg';
import tour12Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour12Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour12Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour12Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour12Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour12Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour12Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour12Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour13 from '../assets/Tour/Tours/Tour-13.jpg';
import tour13Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour13Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour13Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour13Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour13Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour13Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour13Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour13Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour14 from '../assets/Tour/Tours/Tour-14.jpg';
import tour14Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour14Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour14Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour14Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour14Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour14Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour14Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour14Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour15 from '../assets/Tour/Tours/Tour-15.jpg';
import tour15Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour15Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour15Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour15Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour15Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour15Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour15Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour15Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour16 from '../assets/Tour/Tours/Tour-16.jpg';
import tour16Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour16Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour16Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour16Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour16Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour16Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour16Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour16Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour17 from '../assets/Tour/Tours/Tour-17.jpg';
import tour17Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour17Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour17Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour17Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour17Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour17Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour17Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour17Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

import tour18 from '../assets/Tour/Tours/Tour-18.jpg';
import tour18Gallery1 from '../assets/Tour/Gallery/1.jpg';
import tour18Gallery2 from '../assets/Tour/Gallery/2.jpg';
import tour18Gallery3 from '../assets/Tour/Gallery/3.jpg';
import tour18Gallery4 from '../assets/Tour/Gallery/4.jpg';
import tour18Gallery5 from '../assets/Tour/Gallery/5.jpg';
import tour18Gallery6 from '../assets/Tour/Gallery/6.jpg';
import tour18Review1 from '../assets/Tour/Reviews/Pic-1.jpg';
import tour18Review2 from '../assets/Tour/Reviews/Pic-2.jpg';

/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';


/*Accommodations*/
import accommodation1 from '../assets/Accommodation/Accommodations/Acco-1.jpg';
import accommodation1Gallery1 from '../assets/Accommodation/Gallery/1.jpg';
import accommodation1Gallery2 from '../assets/Accommodation/Gallery/2.jpg';

import accommodation2 from '../assets/Accommodation/Accommodations/Acco-2.jpg';
import accommodation2Gallery1 from '../assets/Accommodation/Gallery/1.jpg';
import accommodation2Gallery2 from '../assets/Accommodation/Gallery/2.jpg';

import accommodation3 from '../assets/Accommodation/Accommodations/Acco-3.jpg';
import accommodation3Gallery1 from '../assets/Accommodation/Gallery/1.jpg';
import accommodation3Gallery2 from '../assets/Accommodation/Gallery/2.jpg';

import accommodation4 from '../assets/Accommodation/Accommodations/Acco-4.jpg';
import accommodation4Gallery1 from '../assets/Accommodation/Gallery/1.jpg';
import accommodation4Gallery2 from '../assets/Accommodation/Gallery/2.jpg';

import accommodation5 from '../assets/Accommodation/Accommodations/Acco-5.jpg';
import accommodation5Gallery1 from '../assets/Accommodation/Gallery/1.jpg';
import accommodation5Gallery2 from '../assets/Accommodation/Gallery/2.jpg';

import accommodation6 from '../assets/Accommodation/Accommodations/Acco-6.jpg';
import accommodation6Gallery1 from '../assets/Accommodation/Gallery/1.jpg';
import accommodation6Gallery2 from '../assets/Accommodation/Gallery/2.jpg';


/*Activities*/
import activity1 from '../assets/Activity/Activities/Activity-1.jpg';
import activity1Gallery1 from '../assets/Activity/Gallery/1.jpg';
import activity1Gallery2 from '../assets/Activity/Gallery/2.jpg';

import activity2 from '../assets/Activity/Activities/Activity-2.jpg';
import activity2Gallery1 from '../assets/Activity/Gallery/1.jpg';
import activity2Gallery2 from '../assets/Activity/Gallery/2.jpg';

import activity3 from '../assets/Activity/Activities/Activity-3.jpg';
import activity3Gallery1 from '../assets/Activity/Gallery/1.jpg';
import activity3Gallery2 from '../assets/Activity/Gallery/2.jpg';

import activity4 from '../assets/Activity/Activities/Activity-4.jpg';
import activity4Gallery1 from '../assets/Activity/Gallery/1.jpg';
import activity4Gallery2 from '../assets/Activity/Gallery/2.jpg';

import activity5 from '../assets/Activity/Activities/Activity-5.jpg';
import activity5Gallery1 from '../assets/Activity/Gallery/1.jpg';
import activity5Gallery2 from '../assets/Activity/Gallery/2.jpg';

import activity6 from '../assets/Activity/Activities/Activity-6.jpg';
import activity6Gallery1 from '../assets/Activity/Gallery/1.jpg';
import activity6Gallery2 from '../assets/Activity/Gallery/2.jpg';


/*Events*/
import event1 from '../assets/Event/Events/Event-1.jpg';
import event1Gallery1 from '../assets/Event/Gallery/1.jpg';
import event1Gallery2 from '../assets/Event/Gallery/2.jpg';

import event2 from '../assets/Event/Events/Event-2.jpg';
import event2Gallery1 from '../assets/Event/Gallery/1.jpg';
import event2Gallery2 from '../assets/Event/Gallery/2.jpg';

import event3 from '../assets/Event/Events/Event-3.jpg';
import event3Gallery1 from '../assets/Event/Gallery/1.jpg';
import event3Gallery2 from '../assets/Event/Gallery/2.jpg';

import event4 from '../assets/Event/Events/Event-4.jpg';
import event4Gallery1 from '../assets/Event/Gallery/1.jpg';
import event4Gallery2 from '../assets/Event/Gallery/2.jpg';

import event5 from '../assets/Event/Events/Event-5.jpg';
import event5Gallery1 from '../assets/Event/Gallery/1.jpg';
import event5Gallery2 from '../assets/Event/Gallery/2.jpg';

import event6 from '../assets/Event/Events/Event-6.jpg';
import event6Gallery1 from '../assets/Event/Gallery/1.jpg';
import event6Gallery2 from '../assets/Event/Gallery/2.jpg';


/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog11 from '../assets/Blog/Blogs/Blog-11.jpg';
import blog11Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog11Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog11Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog11Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog11Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog12 from '../assets/Blog/Blogs/Blog-12.jpg';
import blog12Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog12Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog12Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog12Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog12Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/10.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/10.jpg';
import product8Gallery4 from '../assets/Shop/Products/11.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*Partners*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,

    /*About*/
    about1,
    about2,
    about3,

    /*Team*/
    team1,
    team2,
    team3, 
    team4,

    /*Career Introduction*/
    careerIntro,

    /*Positions*/
    position1,
    position2,
    position3,
    position4,
    position5,
    position6,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*FAQs*/ 
    FAQs,

    /*Gallery*/
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,

    /*Destinations*/
    des1,
    des1Gallery1,
    des1Gallery2,
    des1Gallery3,
    des1Gallery4,
    des1Gallery5,
    des1Gallery6,

    des2,
    des2Gallery1,
    des2Gallery2,
    des2Gallery3,
    des2Gallery4,
    des2Gallery5,
    des2Gallery6,

    des3,
    des3Gallery1,
    des3Gallery2,
    des3Gallery3,
    des3Gallery4,
    des3Gallery5,
    des3Gallery6,

    des4,
    des4Gallery1,
    des4Gallery2,
    des4Gallery3,
    des4Gallery4,
    des4Gallery5,
    des4Gallery6,

    des5,
    des5Gallery1,
    des5Gallery2,
    des5Gallery3,
    des5Gallery4,
    des5Gallery5,
    des5Gallery6,

    des6,
    des6Gallery1,
    des6Gallery2,
    des6Gallery3,
    des6Gallery4,
    des6Gallery5,
    des6Gallery6,

    /*Tours*/
    tour1,
    tour1Gallery1,
    tour1Gallery2,
    tour1Gallery3,
    tour1Gallery4,
    tour1Gallery5,
    tour1Gallery6,
    tour1Review1,
    tour1Review2,

    tour2,
    tour2Gallery1,
    tour2Gallery2,
    tour2Gallery3,
    tour2Gallery4,
    tour2Gallery5,
    tour2Gallery6,
    tour2Review1,
    tour2Review2,

    tour3,
    tour3Gallery1,
    tour3Gallery2,
    tour3Gallery3,
    tour3Gallery4,
    tour3Gallery5,
    tour3Gallery6,
    tour3Review1,
    tour3Review2,

    tour4,
    tour4Gallery1,
    tour4Gallery2,
    tour4Gallery3,
    tour4Gallery4,
    tour4Gallery5,
    tour4Gallery6,
    tour4Review1,
    tour4Review2,

    tour5,
    tour5Gallery1,
    tour5Gallery2,
    tour5Gallery3,
    tour5Gallery4,
    tour5Gallery5,
    tour5Gallery6,
    tour5Review1,
    tour5Review2,

    tour6,
    tour6Gallery1,
    tour6Gallery2,
    tour6Gallery3,
    tour6Gallery4,
    tour6Gallery5,
    tour6Gallery6,
    tour6Review1,
    tour6Review2,

    tour7,
    tour7Gallery1,
    tour7Gallery2,
    tour7Gallery3,
    tour7Gallery4,
    tour7Gallery5,
    tour7Gallery6,
    tour7Review1,
    tour7Review2,

    tour8,
    tour8Gallery1,
    tour8Gallery2,
    tour8Gallery3,
    tour8Gallery4,
    tour8Gallery5,
    tour8Gallery6,
    tour8Review1,
    tour8Review2,

    tour9,
    tour9Gallery1,
    tour9Gallery2,
    tour9Gallery3,
    tour9Gallery4,
    tour9Gallery5,
    tour9Gallery6,
    tour9Review1,
    tour9Review2,

    tour10,
    tour10Gallery1,
    tour10Gallery2,
    tour10Gallery3,
    tour10Gallery4,
    tour10Gallery5,
    tour10Gallery6,
    tour10Review1,
    tour10Review2,

    tour11,
    tour11Gallery1,
    tour11Gallery2,
    tour11Gallery3,
    tour11Gallery4,
    tour11Gallery5,
    tour11Gallery6,
    tour11Review1,
    tour11Review2,

    tour12,
    tour12Gallery1,
    tour12Gallery2,
    tour12Gallery3,
    tour12Gallery4,
    tour12Gallery5,
    tour12Gallery6,
    tour12Review1,
    tour12Review2,

    tour13,
    tour13Gallery1,
    tour13Gallery2,
    tour13Gallery3,
    tour13Gallery4,
    tour13Gallery5,
    tour13Gallery6,
    tour13Review1,
    tour13Review2,

    tour14,
    tour14Gallery1,
    tour14Gallery2,
    tour14Gallery3,
    tour14Gallery4,
    tour14Gallery5,
    tour14Gallery6,
    tour14Review1,
    tour14Review2,

    tour15,
    tour15Gallery1,
    tour15Gallery2,
    tour15Gallery3,
    tour15Gallery4,
    tour15Gallery5,
    tour15Gallery6,
    tour15Review1,
    tour15Review2,

    tour16,
    tour16Gallery1,
    tour16Gallery2,
    tour16Gallery3,
    tour16Gallery4,
    tour16Gallery5,
    tour16Gallery6,
    tour16Review1,
    tour16Review2,

    tour17,
    tour17Gallery1,
    tour17Gallery2,
    tour17Gallery3,
    tour17Gallery4,
    tour17Gallery5,
    tour17Gallery6,
    tour17Review1,
    tour17Review2,

    tour18,
    tour18Gallery1,
    tour18Gallery2,
    tour18Gallery3,
    tour18Gallery4,
    tour18Gallery5,
    tour18Gallery6,
    tour18Review1,
    tour18Review2,

    /*Services*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*Accommodations*/
    accommodation1,
    accommodation1Gallery1,
    accommodation1Gallery2,

    accommodation2,
    accommodation2Gallery1,
    accommodation2Gallery2,

    accommodation3,
    accommodation3Gallery1,
    accommodation3Gallery2,

    accommodation4,
    accommodation4Gallery1,
    accommodation4Gallery2,

    accommodation5,
    accommodation5Gallery1,
    accommodation5Gallery2,

    accommodation6,
    accommodation6Gallery1,
    accommodation6Gallery2,

    /*Activities*/
    activity1,
    activity1Gallery1,
    activity1Gallery2,

    activity2,
    activity2Gallery1,
    activity2Gallery2,

    activity3,
    activity3Gallery1,
    activity3Gallery2,

    activity4,
    activity4Gallery1,
    activity4Gallery2,

    activity5,
    activity5Gallery1,
    activity5Gallery2,

    activity6,
    activity6Gallery1,
    activity6Gallery2,

    /*Events*/
    event1,
    event1Gallery1,
    event1Gallery2,

    event2,
    event2Gallery1,
    event2Gallery2,

    event3,
    event3Gallery1,
    event3Gallery2,

    event4,
    event4Gallery1,
    event4Gallery2,

    event5,
    event5Gallery1,
    event5Gallery2,

    event6,
    event6Gallery1,
    event6Gallery2,

    /*Pricing*/
    plan1,
    plan2,
    plan3,

    /*Projects*/
    project1,
    project1Gallery1,
    project1Gallery2,
    project1Gallery3,
    project1Gallery4,
    project1Gallery5,
    project1Gallery6,

    project2,
    project2Gallery1,
    project2Gallery2,
    project2Gallery3,
    project2Gallery4,
    project2Gallery5,
    project2Gallery6,

    project3,
    project3Gallery1,
    project3Gallery2,
    project3Gallery3,
    project3Gallery4,
    project3Gallery5,
    project3Gallery6,

    project4,
    project4Gallery1,
    project4Gallery2,
    project4Gallery3,
    project4Gallery4,
    project4Gallery5,
    project4Gallery6,

    project5,
    project5Gallery1,
    project5Gallery2,
    project5Gallery3,
    project5Gallery4,
    project5Gallery5,
    project5Gallery6,

    project6,
    project6Gallery1,
    project6Gallery2,
    project6Gallery3,
    project6Gallery4,
    project6Gallery5,
    project6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    blog11,
    blog11Gallery1,
    blog11Gallery2,
    blog11Comment1,
    blog11Comment2,
    blog11Comment3,

    blog12,
    blog12Gallery1,
    blog12Gallery2,
    blog12Comment1,
    blog12Comment2,
    blog12Comment3,

    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

};

export default images;